// Updated TranscriptScrollbar.jsx - Now receives transcript data as props
import { Scrollbars } from 'react-custom-scrollbars';
import React from 'react';
import PageLoadingComponent from './PageLoadingComponent';
import TranscriptBody from './TranscriptBody';
import PagerWrapper from './PagerWrapper';
import useTranscriptScroll from './useTranscriptScroll';

function TranscriptScrollbar({
  transcriptData,
  coders,
  selectedExcerptId,
  select,
  page,
  pageCount,
  transcriptID,
  hasEditPermission,
  shouldGotoOtherPage,
  onDeselect,
  snippet,
  search,
  pos
}) {
  const contentLoaded = transcriptData && transcriptData.body;
  
  const {
    scrollbar,
    setParagraphRef,
    onPage,
    handleScrollStop
  } = useTranscriptScroll({
    transcriptData,
    transcriptID,
    page,
    shouldGotoOtherPage,
    snippet,
    search,
    pos,
    select,
    selectedExcerptId,
    onDeselect
  });

  return (
    <div style={{ height: "100%" }} className='transcript-scrollbar'>
      <Scrollbars
        autoHide
        style={{ height: "100%" }}
        ref={scrollbar}
        onScrollStop={handleScrollStop}
      >
        {!contentLoaded ? (
          <PageLoadingComponent />
        ) : (
          <PagerWrapper pageCount={pageCount} onPage={onPage}>
            <TranscriptBody
              setParagraphRef={setParagraphRef}
              transcriptID={transcriptID}
              transcriptData={transcriptData}
              coders={coders}
              selectedExcerptId={selectedExcerptId}
              select={select}
              page={page}
              hasEditPermission={hasEditPermission}
            />
          </PagerWrapper>
        )}
      </Scrollbars>
    </div>
  );
}

export default TranscriptScrollbar;